import React from 'react';

import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Tooltip,
    Grid,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const useStyles = makeStyles({
    table: {
        minWidth: 700,
    },
});

export default function VagasTable(props) {
    const classes = useStyles();
    const openEdit = props.openEdit;
    const vagas = props.vagas
    vagas.sort(function (a, b) {
        return a.title < b.title ? -1 : a.title > b.title ? 1 : 0;
    });

    function salaryFormatter(val) { return val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); }
    function salarysFormataded(val_min, val_max) {
        return `${salaryFormatter(val_min)} até ${salaryFormatter(val_max)}`
    }

    return (
        <>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>Vaga</StyledTableCell>
                            <StyledTableCell align="center">Tipo contrato</StyledTableCell>
                            <StyledTableCell align="center">Benefícios</StyledTableCell>
                            <StyledTableCell align="center">Salário</StyledTableCell>
                            <StyledTableCell align="center">Localização</StyledTableCell>
                            <StyledTableCell align="center">Ações</StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {vagas.length !== 0 &&
                            vagas.map((vaga) => (

                                <StyledTableRow key={`${vaga.title}${vaga.id}`}>
                                    <StyledTableCell component="th" scope="row">
                                        {vaga.title}
                                    </StyledTableCell>
                                    <StyledTableCell align="center">{vaga.type}</StyledTableCell>
                                    <StyledTableCell align="center">{vaga.benefit}</StyledTableCell>
                                    <StyledTableCell align="center">{salarysFormataded(vaga.salary_min, vaga.salary_max)}</StyledTableCell>
                                    <StyledTableCell align="center">{vaga.city.name} - {vaga.city.state.uf}</StyledTableCell>
                                    <StyledTableCell align="center">
                                        <Tooltip title="editar">
                                            <IconButton aria-label="editar" color="secondary" onClick={() => openEdit(vaga)}>
                                                <EditIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </StyledTableCell>
                                </StyledTableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            {vagas.length === 0 &&
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <p>Nenhuma vaga cadastrada</p>
                </Grid>
            }
        </>
    );
}
